import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RouteInfo } from 'src/app/shared/sidebar/sidebar.metadata';
import { ROUTES as ROUTES_2024 } from 'src/app/shared/sidebar/sidebar-2024-routes.config';
import { ROUTES as ROUTES_2025 } from 'src/app/shared/sidebar/sidebar-2025-routes.config';
import { LocalStorageService } from './localstorage.service';
import { VariablesEnum } from 'src/app/auth/enum/variables.enum';
import { AnioInformacionEnum } from '../auth/enum/AnioInformacion.enum';
import { SidebarVisibilityService } from './sidebar.visible.service';
import { RouterLink } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SidebarRoutesService {
  private currentYearSubject = new BehaviorSubject<number>(this.loadInitialYear());
  currentYear$ = this.currentYearSubject.asObservable();

  constructor(private localStorageService: LocalStorageService, private sidebarVisibilityService: SidebarVisibilityService,) {}

  private loadInitialYear(): number {
    const anioSeleccionadoMenu = this.getAnioSeleccionado();
    if(anioSeleccionadoMenu != null){
      this.sidebarVisibilityService.showSidebar();
    }
    const stored = parseInt(anioSeleccionadoMenu.toString(), 10);
    return stored ? parseInt(stored.toString(), 10) : AnioInformacionEnum.AnioInformacion2025;
  }

  getCurrentRoutes(): RouteInfo[] {
    const anioSeleccionadoMenu = this.getAnioSeleccionado();
    return anioSeleccionadoMenu === AnioInformacionEnum.AnioInformacion2024 ? ROUTES_2024 : ROUTES_2025;
  }

  setYear(year: number) {
  localStorage.setItem("anioSeleccionado", year.toString());
  this.currentYearSubject.next(year);
  this.localStorageService.setJsonValue(VariablesEnum.anio_informacion, year);
  }

  getYear(): number {
    return this.getAnioSeleccionado();
  }

  getAnioSeleccionado(): number | null {
    const anioSeleccionadoString = localStorage.getItem("anioSeleccionado");
  if (anioSeleccionadoString != 'null') {
    return parseInt(anioSeleccionadoString, 10);
    } else {
    localStorage.setItem("anioSeleccionado", AnioInformacionEnum.AnioInformacion2025.toString());
    return AnioInformacionEnum.AnioInformacion2025;
    }
  }
}
